// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".noDataMessage___75aJq{padding:16px}.loadingContainer___5Cp4G{display:flex;justify-content:center;padding:8px 0}\n", "",{"version":3,"sources":["webpack://./src/components/Table/TableLoading/TableLoading.css"],"names":[],"mappings":"AAAA,uBAAA,YAAA,CAIA,0BACI,YAAA,CACA,sBAAA,CANJ,aAAA","sourcesContent":[".noDataMessage {\n    padding: 16px;\n}\n\n.loadingContainer {\n    display: flex;\n    justify-content: center;\n    padding: 8px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noDataMessage": "noDataMessage___75aJq",
	"loadingContainer": "loadingContainer___5Cp4G"
};
export default ___CSS_LOADER_EXPORT___;
